
// const inPlayDarkIcon = process.env.PUBLIC_URL + "/Assets/Images/Icons/HomeLeftIcons/inPlayDark.svg";
// const inPlayLightIcon = process.env.PUBLIC_URL + "/Assets/Images/Icons/HomeLeftIcons/inplayLight.svg";

// const todayDarkIcon = process.env.PUBLIC_URL + "/Assets/Images/Icons/HomeLeftIcons/todayDark.svg";
// const todayLightIcon = process.env.PUBLIC_URL + "/Assets/Images/Icons/HomeLeftIcons/todayLight.svg";

// const tomorrowDarkIcon = process.env.PUBLIC_URL + "/Assets/Images/Icons/HomeLeftIcons/tomorrowDark.svg";
// const tomorrowLightIcon = process.env.PUBLIC_URL + "/Assets/Images/Icons/HomeLeftIcons/tomorrowLight.svg";

const promotionDarkIcon = process.env.PUBLIC_URL + "/Assets/Images/Icons/HomeLeftIcons/iconPromotionDark.svg";
const promotionLightIcon = process.env.PUBLIC_URL + "/Assets/Images/Icons/HomeLeftIcons/iconPromotionLight.svg";

const vipClubDarkIcon = process.env.PUBLIC_URL + "/Assets/Images/Icons/HomeLeftIcons/vipClubDark.svg";
const vipClubLightIcon = process.env.PUBLIC_URL + "/Assets/Images/Icons/HomeLeftIcons/vipClubLight.svg";

const affiliateDarkIcon = process.env.PUBLIC_URL + "/Assets/Images/Icons/HomeLeftIcons/affiliateDark.svg";
const affiliateLightIcon = process.env.PUBLIC_URL + "/Assets/Images/Icons/HomeLeftIcons/affiliateLight.svg";

const languageDarkIcon = process.env.PUBLIC_URL + "/Assets/Images/Icons/HomeLeftIcons/languageDark.svg";
const languageLightIcon = process.env.PUBLIC_URL + "/Assets/Images/Icons/HomeLeftIcons/languageLight.svg";

// const liveChatDarkIcon = process.env.PUBLIC_URL + "/Assets/Images/Icons/HomeLeftIcons/liveChatDark.svg";
// const liveChatLightIcon = process.env.PUBLIC_URL + "/Assets/Images/Icons/HomeLeftIcons/liveChatLight.svg";

// const liveTVDarkIcon = process.env.PUBLIC_URL + "/Assets/Images/Icons/HomeLeftIcons/liveTVDark.svg";
// const liveTVLightIcon = process.env.PUBLIC_URL + "/Assets/Images/Icons/HomeLeftIcons/liveTVLight.svg";

// const webinarDarkIcon = process.env.PUBLIC_URL + "/Assets/Images/Icons/HomeLeftIcons/webinarDark.svg";
// const webinarLightIcon = process.env.PUBLIC_URL + "/Assets/Images/Icons/HomeLeftIcons/webinarLight.svg";

export const homeLeftData = [
    // {
    //     id: 0,
    //     name: "In-Play",
    //     to: "/login",
    //     icon1: inPlayDarkIcon,
    //     icon2: inPlayLightIcon,
    // },
    // {
    //     id: 1,
    //     name: "Today",
    //     to: "/login",
    //     icon1: todayDarkIcon,
    //     icon2: todayLightIcon,
    // },
    // {
    //     id: 2,
    //     name: "Tomorrow",
    //     to: "/login",
    //     icon1: tomorrowDarkIcon,
    //     icon2: tomorrowLightIcon,
    // },
    {
        id: 1,
        name: "Promotion",
        to: "/promotion",
        icon1: promotionDarkIcon,
        icon2: promotionLightIcon,
    },
    {
        id: 2,
        name: "VIP Club",
        to: "/vip-club",
        icon1: vipClubDarkIcon,
        icon2: vipClubLightIcon,
    },
    {
        id: 3,
        name: "Affiliate",
        to: "/affiliate",
        icon1: affiliateDarkIcon,
        icon2: affiliateLightIcon,
    },
    // {
    //     id: 2,
    //     name: "Webinar",
    //     to: "/webinar",
    //     icon1: webinarDarkIcon,
    //     icon2: webinarLightIcon,
    // },
    {
        id: 4,
        name: "Language",
        to: "/languages",
        icon1: languageDarkIcon,
        icon2: languageLightIcon,
    },
    // {
    //     id: 5,
    //     name: "Support",
    //     to: "/chat",
    //     icon1: liveChatDarkIcon,
    //     icon2: liveChatLightIcon,
    // },
    // {
    //     id: 6,
    //     name: "Mood",
    //     to: "mood",
    //     icon1: null,
    //     icon2: null,
    // },
]


export const navbarData = [
    {
        id: 1,
        name: 'sportsNav',
        title: 'sports',
        to: '/sports',
        // icon1: sportGoldenIcon,
        // icon2: sportGrayIcon,
    },

    {
        id: 2,
        name: 'casinoNav',
        title: 'casino',
        to: '/casino',
        // icon1: casinoGoldenIcon,
        // icon2: casinoGrayIcon,
    },
    {
        id: 3,
        name: 'slotsNav',
        title: 'slots',
        to: '/slots',
        // icon1: slotsGoldenIcon,
        // icon2: slotsGrayIcon,
    },
    {
        id: 4,
        name: 'fishingNav',
        title: 'fishing',
        to: '/fishing',
        // icon1: virtualGamesGoldenIcon,
        // icon2: virtualGamesGrayIcon,
    },
    {
        id: 5,
        name: 'table',
        title: 'Table',
        to: '/table',
        // icon1: lotteryGoldenIcon,
        // icon2: lotteryGrayIcon,
    },
    {
        id: 6,
        name: 'lotteryNav',
        title: 'lottery',
        to: '/lottery',
        // icon1: lotteryGoldenIcon,
        // icon2: lotteryGrayIcon,
    },
]